import { ActionContext } from 'vuex';

import { ActionClass, MessagesState } from '../../../models';

import { MESSAGES_CONSTS } from '../../../store/messages/messages.consts';

export class SetLocaleAction implements ActionClass {

  public static execute({ commit }: ActionContext<MessagesState, any>, locale: string): void {
    commit(MESSAGES_CONSTS.mutations.setLocale, locale);
  }

}
